import { createSelector } from 'reselect';

const hasFocusState = createSelector(
  state => state.elements.Focus.hasFocus,
  hasFocus => hasFocus,
);
export default hasFocusState;
